import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProductionLineRoutingModule } from './production-line-routing.module';
import { SharedModule } from '../shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../material.module';
import { ThreeModule } from '../three.module';
import { ProductionLinesComponent } from 'src/app/components/production-lines/production-lines.component';
import { ProductionLineComponent } from '../../components/production-lines/production-line/production-line.component';
import { ProductionLineCardComponent } from 'src/app/components/production-lines/production-line-card/production-line-card.component';

@NgModule({
  declarations: [
    ProductionLinesComponent,
    ProductionLineComponent,
    ProductionLineCardComponent,
  ],
  exports: [
    ProductionLinesComponent,
    ProductionLineComponent,
    ProductionLineCardComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    ThreeModule,
    SharedModule,
    CommonModule,
    ProductionLineRoutingModule,
  ],
})
export class ProductionLineModule {}
